import React from "react";

import { motion } from "framer-motion";

import { slideIn } from "../../utils/motionVariants";

const SlideInContainer = ({ duration, delay, children }) => {
  return (
    <motion.div
      variants={slideIn}
      viewport={{ once: true }}
      initial="leftSlideInInitial"
      whileInView="leftSlideIn"
      transition={{
        duration,
        delay,
      }}
    >
      {children}
    </motion.div>
  );
};

export default SlideInContainer;
